import { PaymentMethod, PaypalTransactionStatus, tipalti } from '@round/api';
import capitalize from 'lodash/capitalize';
import moment from 'moment';

type LabelProps<T extends PaymentMethod> = {
    status: T extends 'tipalti' ? tipalti.PaymentTransactionStatus : PaypalTransactionStatus;
    method: T;
    scheduledDate?: string | null;
};

const getTipaltiPaymentStatusLabel = ({ status, scheduledDate }: Omit<LabelProps<'tipalti'>, 'method'>) => {
    const labels: Record<tipalti.PaymentTransactionStatus, string> = {
        SUBMITTED_TO_TIPALTI: 'Submitted, awaiting approval',
        SUBMITTED: 'Submitted, awaiting approval',
        PAID: 'Paid',
        REJECTED: 'Rejected',
        SCHEDULED: scheduledDate ? `Scheduled, ${moment(scheduledDate).format('DD MMM YY')}` : 'Scheduled',
        DEFERRED: 'Deferred',
        DEFERRED_INTERNAL: 'Deferred',
        CANCELED: 'Canceled',
        CLEARED: 'Cleared',
        FRAUD_REVIEW: 'Under Review',
        PENDING_PAYER_FUNDS: 'Pending',
        INTERNAL_VALUE: 'Pending',
    };

    return labels[status] || capitalize(status.replace(/_/g, ' '));
};

const getPaypalPaymentStatusLabel = (status: PaypalTransactionStatus) => {
    const labels: Record<PaypalTransactionStatus, string> = {
        BLOCKED: 'Blocked',
        FAILED: 'Failed',
        ONHOLD: 'On Hold',
        PENDING: 'Pending',
        RETURNED: 'Returned',
        REFUNDED: 'Refunded',
        REVERSED: 'Reversed',
        SUCCESS: 'Success',
        UNCLAIMED: 'Unclaimed',
    };

    return labels[status] || capitalize(status.replace(/_/g, ' '));
};

export const getPaymentTransactionStatusLabel = <T extends PaymentMethod>({
    status,
    method,
    scheduledDate,
}: LabelProps<T>) => {
    if (method === 'tipalti') {
        return getTipaltiPaymentStatusLabel({ status: status as tipalti.PaymentTransactionStatus, scheduledDate });
    }

    return getPaypalPaymentStatusLabel(status as PaypalTransactionStatus);
};
